export default __webpack_public_path__ + "static/media/E.74aed6d2.wav";